//src/components/PrivateRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { isTokenExpired } from '../utils/jwtUtils';

interface PrivateRouteProps {
  children: React.ReactElement;
  token: string | null;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, token }) => {
  // Si no hay token, redirigir al login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Si el token está expirado localmente, redirigir al login
  // La validación con el backend se hará después, pero no bloqueamos el acceso
  // si el token local es válido
  if (isTokenExpired(token)) {
    return <Navigate to="/login" replace />;
  }

  // Si hay token y no está expirado localmente, permitir acceso
  // La validación periódica con el backend se manejará en Dashboard
  return children;
};

export default PrivateRoute;
 